// extracted by mini-css-extract-plugin
export default {"root":"SpecialistAvatar_root__RJ2WQ","wrapperAvatar":"SpecialistAvatar_wrapperAvatar__tIfJr","imgAvatar":"SpecialistAvatar_imgAvatar__86NWp"};